var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 14.75C6.825 14.75 7.5 14.075 7.5 13.25V5.75C7.5 4.925 6.825 4.25 6 4.25C5.175 4.25 4.5 4.925 4.5 5.75V13.25C4.5 14.075 5.175 14.75 6 14.75ZM10.5 5.75V13.25C10.5 14.075 11.175 14.75 12 14.75C12.825 14.75 13.5 14.075 13.5 13.25V5.75C13.5 4.925 12.825 4.25 12 4.25C11.175 4.25 10.5 4.925 10.5 5.75Z",
    fill: "#29282D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBlack);
export default __webpack_public_path__ + "static/media/pauseBlack.e2121215a3aea91eb7b1bf6166f35af3.svg";
export { ForwardRef as ReactComponent };